export default {
    getModule: state => state.module,
}